import { render, staticRenderFns } from "./UserRecordAudio.vue?vue&type=template&id=6b0e0970&"
import script from "./UserRecordAudio.vue?vue&type=script&lang=js&"
export * from "./UserRecordAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports